<template>
  <div class="text-left bg-slate-50" >

          <div v-if="moduleRoute === 'users'" class="grid grid-cols-6 gap-1 text-center mt-1 mb-1" >

          </div>
          <div v-else-if="moduleRoute === 'audits'" class="grid grid-cols-2 gap-1 text-center mt-1 mb-1" >

          </div>
          <div v-else class="grid grid-cols-6 gap-1 text-center mt-1 mb-1" >
              <i class="fab fa-whatsapp text-xl" @click="openwhatsAppClicked(itemData)"></i>
              <i class="fas fa-phone-alt text-xl" @click="openPhoneDialerClicked(itemData)"></i>
              <i class="fas fa-sms text-xl" @click="openSmsDialerClicked(itemData)"></i>
              <i class="fab fa-stripe-s text-xl"></i>
              <i class="fas fa-calendar-check text-xl"></i>
              <i class="fas fa-map-marker-alt text-xl" @click="openCheckInMap(itemData)"></i>
          </div>
    

          <div v-for="column in columns" v-bind:key="column.id">  
            <span v-if="column.caption!='Name'">
              <span class="">{{column.caption}} : {{itemData[column.dataField]}}</span> <br>        
            </span>
          </div>

    <!-- <div v-for="column in columns" v-bind:key="column.id" >  
      
      <span v-if="column.caption=='Name'">
        <span class="text-lg font-weight-bold">{{itemData[column.dataField]}}</span> <br>        
      </span>
      <span v-if="column.caption!='Name'">
        <span class="text-sm">{{column.caption}} : {{itemData[column.dataField]}}</span> <br>        
      </span>
    </div>
     -->
    <span style="visibility:hidden; font-size:1px;" id="rowId">{{itemData.id}}</span>

  </div>
</template>
<style scoped>
    .noselect {
        -webkit-touch-callout: none;
        /* iOS Safari */
        -webkit-user-select: none;
        /* Safari */
        -khtml-user-select: none;
        /* Konqueror HTML */
        -moz-user-select: none;
        /* Firefox */
        -ms-user-select: none;
        /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently supported by Chrome and Opera */
    }

    .no-decoration{
      text-decoration: none;
      color: black;
    }

    .no-decoration:focus{
      text-decoration: none;
      color: black;

    }

    .no-decoration:hover{
      text-decoration: none;
      color: black;
    }


    </style>

<script>

export default {
  props: {
    moduleRoute: String,
    itemData: {
      type: Object,
      default: () => {},
    },
    columns: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    
    goToDetails(itemId){
      this.$inertia.get(this.routeDef+"/"+itemId);
    }    
    
    ,goToEdit(itemId){
        this.$inertia.get(this.routeDef+"/"+itemId+"/edit");
    },
    openwhatsAppClicked(itemData){
      app.openWhatsApp(itemData);
      console.log(itemData);
    },
    openPhoneDialerClicked(itemData){
      app.openPhoneDialer("2378745452");
      console.log(itemData);
    },
    openSmsDialerClicked(itemData){
      app.openSmsDialer("+91783551654");
      console.log(itemData);
    },  
    openCheckInMap(itemData){
    //  app.openCheckInMap("");
      app.startPunchMap();
      console.log(itemData);
    }, 
    getCoordinates(longitude,latitude){
       alert(longitude+"::"+latitude);
    } 
  },
  mounted() {
    window.getCoordinates = this.getCoordinates;

  },
};
</script>
